import { useRef, useState } from "react";

import { IconButton, TextField } from "@mui/material";
import classNames from "classnames";
import { IoSend } from "react-icons/io5";

export function Message() {
	const [text, setText] = useState("");
	const prevKeyCode = useRef("");

	return (
		<div className="item-separator-big">
			<div className="input-box item-separator-small">
				<TextField
					fullWidth
					variant="standard"
					slotProps={{
						input: {
							disableUnderline: true,
							className: "normal-text",
						},
					}}
					multiline
					style={{ height: "calc(100% - 2px)", overflowY: "auto" }}
					placeholder="Type a message..."
					value={text}
					onChange={(event) => {
						setText(event.target.value);
					}}
					onKeyDown={(event) => {
						if (
							event.code === "Enter" &&
							(prevKeyCode.current === "ShiftLeft" ||
								prevKeyCode.current === "ShiftRight")
						) {
							event.preventDefault();
						}
						prevKeyCode.current = event.code;
					}}
				/>
				<IconButton type="submit" disabled={text.trim() === ""}>
					<IoSend
						className={classNames("normal-icon send-icon", {
							disabled: text.trim() === "",
						})}
					/>
				</IconButton>
			</div>
		</div>
	);
}
